import React, { useEffect } from 'react';

interface PhilosophyProps {
  embedded?: boolean; // When true, renders without page wrapper
}

const Philosophy: React.FC<PhilosophyProps> = ({ embedded = false }) => {
  useEffect(() => {
    if (!embedded) {
      document.title = 'Our Philosophy | NextPangaea';
    }
  }, [embedded]);

  const content = (
    <>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-np-50 to-white py-16 md:py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="font-playfair text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Our Philosophy
            </h1>
            <div className="w-24 h-1 bg-np-500 mx-auto"></div>
          </div>
        </section>

        {/* Main Philosophy Content */}
        <section className="py-16 md:py-20">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-6 text-lg text-gray-700 leading-loose">
              <p>
                At NextPangaea, <span className="text-np-700 font-semibold">customer satisfaction</span> is our most valuable asset.
              </p>

              <p>
                We are dedicated to supporting brands in crafting cosmetics that highlight natural beauty while meeting global expectations.
              </p>

              <div className="my-8 py-6 px-8 bg-np-50 rounded-xl border-l-4 border-np-500">
                <p className="text-np-800 font-playfair text-xl leading-relaxed italic">
                  Our expertise is built on years of experience, cutting-edge technologies, and the finest raw materials, ensuring the highest quality in every product.
                </p>
              </div>

              <p>
                As leaders in <span className="text-gray-900 font-semibold">Korean private label cosmetics</span>, we take pride in offering innovative solutions tailored to your brand's needs.
              </p>

              <p>
                We provide a diverse range of <span className="text-gray-900 font-semibold">skincare and haircare products</span>, including mask packs, that inspire creativity and align with market trends.
              </p>

              <p>
                By collaborating with us, you gain a partner ready to adapt to the ever-changing demands of the cosmetic industry.
              </p>

              <p>
                Next Pangaea remains committed to embracing new ideas and innovations, empowering brands to grow and succeed in a competitive global market.
              </p>
            </div>
          </div>
        </section>
    </>
  );

  if (embedded) {
    return content;
  }

  return (
    <div className="min-h-screen bg-white">
      {content}
    </div>
  );
};

export default Philosophy;
